import { render, staticRenderFns } from "./PersonSearchField.vue?vue&type=template&id=19b8ebee&scoped=true"
import script from "./PersonSearchField.vue?vue&type=script&lang=ts"
export * from "./PersonSearchField.vue?vue&type=script&lang=ts"
import style0 from "./PersonSearchField.vue?vue&type=style&index=0&id=19b8ebee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8ebee",
  null
  
)

export default component.exports